const outStandingBalance = {
    list:{
        providersOutstandingBalance:'Providers outstanding balance List',
        searchPlaceholder:'Search by provider name or provider id',
        providerNumber: 'Provider id',
        providerName: 'Provider name',
        outstandingBalance: 'Outstanding balance',
    },
    details:{
        transactions: 'Transactions',
        settlements: 'Settlements',
        providerOutstandingDetails:"'s outstanding details",
        cash: 'cash',
        online: 'online',
        admin_resolution: 'Resolved by admin',
    },
    transactions: {
        pageTitle: 'Transactions (since the last settlement) ',
        emptyState: 'There is no unsettled payment transactions yet',
        outstandingBalance: 'Outstanding balance',
        settle: 'Settle',
        branchName: 'Branch name',
        appointmentNumber: 'Appointment id',
        paymentType: 'Payment type',
        date:'Date',
        paidAmount: 'Paid amount',
        settlementAmount:'Settlement amount',
        sr: 'SR',
        settlementConfirmation: 'Settlement confirmation',
        serviceProvider: 'Service provider',
        settlementStatus: 'Settlement status',

    },
    fixedCommissionFees: {
        pageTitle: 'Fixed commission fees',
        emptyState: 'There is no fixed commission fees yet',
        month: 'Month',
        amount: 'Amount'
    },
    settlements: {
        pageTitle:'Previous settlements',
        emptyState: 'There is no settled payment transactions yet',
        date: 'Date',
        time: 'Time',
        status: 'Status',
        startDate: 'Start date',
        endDate: 'End date',
        settlementAmount: 'Settlement amount',
        exportTransactions: 'Export transactions',
        exportSettlements: 'Export settlements'
      
    }


};

export default outStandingBalance;